import React from 'react';
import { IconImage } from '@tripian/react';

import config from '../../../config';

/**
 * Travel Guide
 * Trip Plan
 */

interface ITripAppMenu {
  onClickBookings: () => void;
  onClickFavorites: () => void;
}

const TripAppMenu: React.FC<ITripAppMenu> = ({ onClickBookings, onClickFavorites }) => (
  <>
    {/* YOUR BOOKINGS */}
    {config.HIDE_RESTAURANT_RESERVATIONS && config.HIDE_TOURS_AND_TICKETS ? null : (
      <div className="app-nav-icon-image tooltip" onClick={onClickBookings} onKeyPress={() => {}} role="button" tabIndex={0}>
        <div className="iconImage">
          <IconImage type="BOOKINGS" />
        </div>
        <span className="iconImageText hide-s">Your Bookings</span>
      </div>
    )}

    {/* FAVORITES */}
    <div className="app-nav-icon-image app-nav-icon-image-hide-s tooltip hide-s" onClick={onClickFavorites} onKeyPress={() => {}} role="button" tabIndex={0}>
      <div className="iconImage">
        <IconImage type="FAVORITES" />
      </div>
      <span className="iconImageText">Favorites</span>
    </div>
  </>
);

export default TripAppMenu;
